import { createFileRoute } from '@tanstack/react-router';
import { SegmentInRouteView } from '@/pages/workspaces/integrations/segment-in/routing';
import { LastWorkspaceResolver } from './-components';

/**
 * No `appBundle`: this URL has no `journeys` segment, and the bundle-aware branch of the resolver
 * rebuilds the target from the bundle prefix — which would find no `/journeys/` here, drop the
 * sub-path, and land on the Journeys home instead of this connector.
 */
function SegmentInRoute() {
  return (
    <LastWorkspaceResolver>
      <SegmentInRouteView />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/integrations/segment_in')({
  component: SegmentInRoute,
});
